/**
 * Modo de operación del PMIS — flag persistente que bloquea TODO el
 * pipeline de seeds para que el admin pueda usar el sistema con datos
 * reales sin que los seeds "resuciten" al navegar entre módulos.
 *
 * Estados:
 *   - **demo** (default): los seeds corren normal. El PMIS se auto-puebla
 *     con datos de ejemplo (Budgets, AFEs, SOs, personal, eventos, riesgos,
 *     stakeholders, listas de distribución, configuración de notificaciones).
 *     Útil para sustentaciones y testing inicial.
 *   - **operacion**: TODO el seeding queda neutralizado. Cada `ensureSeed*`
 *     y `seedIfEmpty()` se vuelven no-op. La base se mantiene como la dejó
 *     el último Reset Total + cualquier dato que el admin haya creado
 *     manualmente. Es el modo "producción local" — uso real.
 *
 * Transiciones:
 *   - `wipeAllTables()` (Reset Total) → activa modo operación.
 *   - `resetSeedDemo()` (Restablecer demo) → desactiva modo operación.
 *   - `restaurarDesdeBackup()` también activa modo operación (los datos
 *     restaurados son reales del usuario, no demo).
 *
 * Persistencia: `localStorage["pmis_modo_operacion"]`. Sobrevive a reloads,
 * que es la razón de ser de este flag (los seeds antes resurgían en cada
 * reload porque `seedPromise` se reinicia al recargar el módulo).
 *
 * Storage key con prefijo `pmis_*` para que entre en el backup completo.
 */

const KEY = "pmis_modo_operacion";

export type ModoOperacion = "demo" | "operacion";

export function leerModoOperacion(): ModoOperacion {
  try {
    return localStorage.getItem(KEY) === "1" ? "operacion" : "demo";
  } catch {
    return "demo";
  }
}

export function estaEnModoOperacion(): boolean {
  return leerModoOperacion() === "operacion";
}

export function activarModoOperacion(): void {
  try {
    localStorage.setItem(KEY, "1");
  } catch {
    // localStorage no disponible — ignoramos (peor caso: re-seed al reload).
  }
}

export function desactivarModoOperacion(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
